module.exports = __webpack_public_path__ + "img/graduate-a-girl-projekt-1.f0149233.jpg";